import defaultPalette from '../palette';
export default (function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? defaultPalette : _b;
    return {
        MuiBadge: {
            badge: {
                fontWeight: 600,
            },
            colorSecondary: {
                color: palette.vitality.contrastText,
                backgroundColor: palette.vitality.light,
            },
        },
    };
});
